// These constants must match the values in their respective U_XXXConstants.pas for the corresponding API DLL.
export const externalConstants = {
  // From U_LibraryConstants.pas
  documentType: {
    cdocExternal: -2,
    cdocUnknown: -1,
    cdocInvoice: 3,
    cdocWork: 4,
    cdocQuote: 5,
    cdocPurchase: 6,
    cdocLibrary: 7,
    cdocInstallation: 8,
  },

  // From U_StructureConstants.pas
  dimensionAttributeIdentifiers: {
    cdaiMultiplier: 100,

    cdaiUnknown: 0,
    cdaiLength: 1,
    cdaiChordLength: 2,
    cdaiDiagonalLength: 3,
    cdaiAbsoluteOutageAfterElbow: 4,
    cdaiHeight: 5,
    cdaiAbsoluteAngleLevel: 6,
    cdaiArcAngle: 7,
    cdaiAbsoluteArcRadius: 8,
    cdaiArcLength: 9,
    cdaiChordHeight: 10,
    cdaiOutageDirection: 11,
    cdaiLeafLength: 12,
    cdaiLeafClearance: 13,
    cdaiFrameLength: 14,
    cdaiFrameClearance: 15,

    cdaiDiagonalArcLength: 16,
    cdaiArcRadius: 17,

    cdaiDoorGlassWidth: 50,
  },

  dimensionOrientation: {
    coriUnknown: 0,
    coriDown: 1,
    coriRight: 2,
    coriUpRight: 3,
    coriUp: 4,
    coriUpLeft: 5,
    coriLeft: 6,
    coriDownLeft: 7,
    coriDownRight: 8,
    coriAdhocUnknown: 9,
  },

  edgeTypeClassification: {
    cetcSmartEdges: 1,
    cetcAdhocEdges: 2,
  },

  dimensionOutageDirection: {
    cdodNA: 0,
    cdodLevelPlumb: 1, // 0001
    cdodPositive: 2, // 0010
    cdodNegative: 3, // 0011
    cdodUnknown: 4, // 0100
  },

  doorTypes: {
    cdcoNone: 2,
    cdcoLeft: 4,
    cdcoRight: 5,
    cdcoDouble: 6,
    cdcoSingleInnerSlidingLeft: 9,
    cdcoSingleInnerSlidingRight: 10,
    cdcoBypassInnerSlideLeft: 11,
    cdcoBypassInnerSlideRight: 12,
    cdcoDoubleSlideApartInner: 13,
    cdcoDoubleSlideApartOuter: 14,
  },

  parallelogramMeasureMethods: {
    cpmmUnknown: 0,
    cpmmHeightAndOOS: 1,
    cpmmHeightAndDiagonal: 2,
    cpmmDiagonalAndAngle: 3,
    cpmmHeightAndAngle: 4,
  },

  cutoutTypes: {
    ccttUnknown: 0,
    ccttDorma: 1,
    ccttMouseEars: 3,
    ccttRectangularNotch: 4,
    ccttRoundNotch: 5,
    ccttRectangleSingleHole: 6,
    ccttRectangleDoubleHole: 7,
    ccttSingleHole: 9,
    ccttDoubleHole: 10,
    ccttTripleHole: 11,
    ccttUNotch: 12,
    ccttInsetRound: 13,
    ccttRadiusCorner: 14,
    ccttDoubleRectangularNotch: 15,
    ccttAngledCorner: 16,
    ccttInsetRect: 17,
    ccttRectangularHole: 19,
    ccttQuadHole: 21,
    ccttUNotchSingleHole: 22,
    ccttCoating: 23,
    ccttStamp: 24,
    ccttMetalPoint: 25,
  },

  expressTaxMethods: {
    cetmExcludesTax: 1,
    cetmIncludesTax: 2,
    cetmCalculateTax: 3,
  },

  // From U_WebsiteConstants.pas
  summaryItems: {
    csuiPrice: 'Price',
  },

  quoteDetailItems: {
    cqdiFreightIn: 'FreightIn',
    cqdiMinExcess: 'MinExcess',
    cqdiDiscount: 'Discount',
  },

  barrierShapeTemplates: {
    cbshUnknown: 0,
    cbshStraightRun: 1,
    cbshLShape: 2,
    cbshUShape: 3,
    cbshStair: 4,
    cbshStyleImage: 5,
    cbshRBG1: 6,
    cbshRBG2: 7,
    cbshRBG3: 8,
    cbshCustom: 9,
  },

  // From U_GlassProConstants.pas
  statusIds: {
    cstsQuoteDraftIncomplete: 101,
    cstsQuoteDraftToCheck: 102,
    cstsQuoteReadyToSend: 105,
    cstsQuoteSentToCustomer: 110,
    cstsQuoteUndecided: 111,
    cstsQuoteWon: 115,
    cstsQuoteLost: 116,
    cstsQuoteWonViaRevision: 117,
    cstsQuoteAged: 118,
    cstsQuoteCancelled: 120,
    // These aren't from U_GlassProConstants but makes sense to keep them with the others.
    cstsQuoteWonAwaitingOptionalDeposit: -1,
    cstsQuoteWonAwaitingCompulsoryDeposit: -2,

    cstsInvoiceDraftIncomplete: 601,
    cstsInvoiceDraftToCheck: 602,
    cstsInvoiceReadytoSend: 605,
    cstsInvoiceSentAwaitingPayment: 610,
    cstsInvoiceSentCreditNote: 611,
    cstsInvoiceRetentionHeld: 613,
    cstsInvoicePaid: 615,
    cstsInvoiceFullyCredited: 616,
    cstsInvoiceBadDebt: 620,
    // These aren't from U_GlassProConstants but makes sense to keep them with the others.
    cstsInvoiceSentAwaitingPaymentOverdue: -3,
    cstsInvoiceRetentionHeldOverdue: -4,
  },

  depositHandling: {
    cwdhAllow: 1, // Customer will be prompted to pay the deposit after accepting the quote
    cwdhForce: 3, // Customer must pay the deposit in order to accept the quote
  },

  invoicePaymentHandling: {
    cwihAllowFullOnly: 1,
    cwihAllowFullOrPartial: 2,
    cwihAllowViaAccountingInterface: 3,
  },

  knownEdgeFinishes: {
    cefiArris: -2,
    cefiPolish: -1,
  },

  bevelState: {
    cbvsNone: 0,
    cbvsFrontOnly: 1,
    cbvsBackOnly: 2,
    cbvsBoth: 3,
    cbvsSplit: 4,
  },

  cutStyle: {
    cprtBevel: 11,
    cprtMitre: 12,
  },

  processType: {
    cprtIGUGas: 24,
    cprtIGUBar: 25,
  },

  pricingMode: {
    cpmoUnknown: 0,
    cpmoSupplier: 1,
    cpmoPriceBracket: 2,
    cpmoPriceBook: 3,
    cpmoStockCost: 4,
  },

  componentType: {
    ccotUnknown: 0,
    ccotGlass: 1,
    ccotProcess: 2,
    ccotProduct: 3,
    ccotNote: 4,
    ccotTransformation: 5,
    ccotPane: 7,
    ccotDefaultGlass: 8,
    ccotMeasure: 9,
  },

  chargeableType: (() => {
    const cchtUnknown = 0;
    const cchtSundry = 1;
    const cchtShower = 2;
    const cchtShopfront = 3;
    const cchtComplexAssembly = 4;
    const cchtMerchandise = 5;
    const cchtSheet = 6;
    const cchtPackage = 7;
    const cchtNote = 8;
    const cchtAluminiumRail = 9;
    const cchtService = 10;
    const cchtBalustrade = 11;
    const cchtSunshade = 12;
    const cchtSplashback = 14;
    const cchtWardrobe = 15;
    const cchtSurvey = 16;
    const cchtMeasureTask = 17;

    const cchtsMultipart = [
      cchtShower,
      cchtShopfront,
      cchtPackage,
      cchtAluminiumRail,
      cchtBalustrade,
      cchtSunshade,
      cchtSplashback,
      cchtWardrobe,
    ];

    return {
      cchtUnknown,
      cchtSundry,
      cchtShower,
      cchtShopfront,
      cchtComplexAssembly,
      cchtMerchandise,
      cchtSheet,
      cchtPackage,
      cchtNote,
      cchtAluminiumRail,
      cchtService,
      cchtBalustrade,
      cchtSunshade,
      cchtSplashback,
      cchtWardrobe,
      cchtSurvey,
      cchtMeasureTask,

      cchtsMultipart,
      cchtsLibrary: [...cchtsMultipart, cchtSheet],
      cchtsPlusDesigner: [cchtShower, cchtPackage, cchtSheet],
      cchtStrings: {
        [cchtShower]: 'Shower',
        [cchtShopfront]: 'Shopfront',
        [cchtMerchandise]: 'Sundry',
        [cchtSheet]: 'Glass',
        [cchtPackage]: 'Job',
        [cchtNote]: 'Note',
        [cchtAluminiumRail]: 'Railing',
        [cchtService]: 'Service',
        [cchtBalustrade]: 'Balustrade',
        [cchtSunshade]: 'Sunshade',
        [cchtSplashback]: 'Splashback',
        [cchtWardrobe]: 'Wardrobe',
        [cchtSurvey]: 'Measure',
      } as Record<number, string>,
      cchtStringsWeb: {
        [cchtShower]: 'Shower',
        [cchtShopfront]: 'Shopfront',
        [cchtMerchandise]: 'Sundry',
        [cchtSheet]: 'Glass',
        [cchtPackage]: 'Job / Glass',
        [cchtNote]: 'Note',
        [cchtAluminiumRail]: 'Railing',
        [cchtService]: 'Service',
        [cchtBalustrade]: 'Balustrade',
        [cchtSunshade]: 'Sunshade',
        [cchtSplashback]: 'Splashback',
        [cchtWardrobe]: 'Wardrobe',
        [cchtSurvey]: 'Measure',
      } as Record<number, string>,
      cchtLiteClassNames: {
        [cchtShower]: 'Shower',
        [cchtShopfront]: 'Shopfront',
        [cchtPackage]: 'Package',
        [cchtAluminiumRail]: 'Railing',
        [cchtBalustrade]: 'Balustrade',
        [cchtSplashback]: 'Splashback',
      } as Record<number, string>,
    };
  })(),

  dialogMessageIdentifiers: {
    cdlgLoseCustomPanelSize: 'LoseCustomPanelSize',
  },

  // TODO should this be coming from the backend instead of hard coded here?
  newGlassCopy: (() => {
    const cngcNone = 0;
    const cngcMakeup = 1;
    const cngcMakeupAndGlass = 2;
    const cngcMakeupGlassProcessing = 3;

    return {
      cngcNone,
      cngcMakeup,
      cngcMakeupAndGlass,
      cngcMakeupGlassProcessing,

      cngcStrings: {
        [cngcNone]: 'Nothing',
        [cngcMakeup]: 'Unit Type',
        [cngcMakeupAndGlass]: 'Glass Panes',
        [cngcMakeupGlassProcessing]: 'Glass Panes and Processing',
      } as Record<number, string>,
    };
  })(),

  newProductCopy: (() => {
    const cnpcNone = 0;
    const cnpcCategory = 1;
    const cnpcProduct = 2;

    return {
      cnpcNone,
      cnpcCategory,
      cnpcProduct,

      cnpcStrings: {
        [cnpcNone]: 'Nothing',
        [cnpcCategory]: 'Category',
        [cnpcProduct]: 'Product and Colour',
      } as Record<number, string>,
    };
  })(),

  sendBookOrderMode: {
    cxghUnknown: 0,
    cxghGlassOnly: 1,
    cxghHardwareOnly: 2,
    cxghBoth: 3,
    cxghAsk: 4,
  },

  shapeTypes: {
    chspSmartShape: 0,
    chspRectangle: 1,
    chspParallelogram: 5,
    chspRakedRectangle: 6,
    chspPolygon: 7,
    chspCircle: 8,
    chspOval: 9,
    chspEllipse: 10,
    chspAnchoredQuad: 12,
    chspTriangle: 13,
    chspCustomShape: 15,
  },
};
